export default __webpack_public_path__ + "static/media/Group 460.ee31d3ec.png";